
































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import { Bar } from 'vue-chartjs'
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
// import Chart from "chart.js";
import LineChart from "@/components/chart/LineChart.vue";
import ServiksChart from "@/components/chart/ServiksChart.vue";
import DjjChart from "@/components/chart/DjjChart.vue";
import HisChart from "@/components/chart/HisChart.vue";
import TandaVitalChart from "@/components/chart/TandaVitalChart.vue";
// import PlanetChart from "@/components/chart/PlanetChart.vue";
// import CommitChart from "@/components/chart/CommitChart";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import SvcPartograf from "@/services/Partograf";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import storePartograf from "@/store/modules/Partograf";
// import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";

import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import { Tensi } from "@/types/asesmen";
import { CatatanPersalinan } from "@/types/partograf";
import CardCatatanPersalinan from "@/components/pemeriksaan/partograf/CardCatatanPersalinan.vue";
import CardInfoBayiLahir from "@/components/pemeriksaan/partograf/CardInfoBayiLahir.vue";
import TabelObservasi from "@/components/pemeriksaan/partograf/TabelObservasi.vue";
import PartografTimeHeader from "@/components/chart/PartografTimeHeader.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { confirmRemove } from "@/utility/CommonHelper";
import {
  anchorOf,
  hasStoredAnchor,
  buildSlots,
  floorToHalfHour,
  resolveIndex,
  isSlotEmpty,
  kolomLabel,
  gridRangeLabel,
  jamTampil,
  pembuatLabel,
  toMoment,
  toSqlDateTime,
  blankSlot,
  slotLabel,
  SLOT_COUNT,
  SQL_FORMAT,
} from "@/utility/PartografHelper";

@Component({
  components: {
    //
    LineChart,
    DjjChart,
    HisChart,
    ServiksChart,
    // CommitChart
    TekananDarah,
    FrekuensiNadi,
    TandaVitalChart,
    CardCatatanPersalinan,
    CardInfoBayiLahir,
    TabelObservasi,
    PartografTimeHeader,
    VCDateTimePicker,
  },
  inject: { isReadOnly: { default: () => () => false } },
})
export default class Partograf extends Vue {
  // @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  ketubanPecah: any = null;
  ketubanStatus = "belum";
  mulesSejak: any = null;
  saving = false;
  deleting = false;
  subTab = "obs";
  dialogSign = false;
  passwordSign = "";
  signing = false;
  g = null;
  p = null;
  a = null;
  nama_bapak = "";
  tempat_asal = "";
  masuk_tanggal_pukul: any = null;
  djj = null;
  serviks = null;
  kepala = null;
  jamAktual: any = null;
  editingIndex: number | null = null;
  durasi = null;
  kontraksi = null;
  optionKepala = [
    { id: 5, nama: "5/5" },
    { id: 4, nama: "4/5" },
    { id: 3, nama: "3/5" },
    { id: 2, nama: "2/5" },
    { id: 1, nama: "1/5" },
    { id: 0, nama: "0/5" },
  ];
  optionKontraksi = [
    { id: 5, nama: "5 Kali" },
    { id: 4, nama: "4 Kali" },
    { id: 3, nama: "3 Kali" },
    { id: 2, nama: "2 Kali" },
    { id: 1, nama: "1 Kali" },
  ];
  // sistole: null;
  // diastole: null;
  nadi = null;
  sistole = null;
  diastole = null;

  // === Field WHO baru per entry ===
  air_ketuban = null;
  moulase = null;
  oksitosin_iu = null;
  oksitosin_tetes = null;
  obat_cairan_iv = "";
  suhu = null;
  protein_urin = null;
  aseton_urin = null;
  volume_urin = null;

  optionAirKetuban = [
    { text: "U — Utuh", value: "U" },
    { text: "J — Jernih", value: "J" },
    { text: "M — Mekonium", value: "M" },
    { text: "D — Darah", value: "D" },
    { text: "K — Kering", value: "K" }
  ];
  optionMoulase = [
    { text: "0 — Tulang terpisah", value: "0" },
    { text: "+ — Saling menyentuh", value: "+" },
    { text: "++ — Tumpang tindih dpt dipisah", value: "++" },
    { text: "+++ — Tumpang tindih tdk dpt dipisah", value: "+++" }
  ];
  optionUrinProtein = ["negatif", "trace", "+", "++", "+++"];
  optionUrinAseton = ["negatif", "+", "++", "+++"];

  setTensi(val: Tensi) {
    this.tensi = {
      sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
      diastole:
        !val.diastole && val.diastole != 0 ? null : Number(val.diastole),
    };
  }

  set tensi(val: Tensi) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
  }

  get tensi(): Tensi {
    return {
      sistole: this.sistole,
      diastole: this.diastole,
    };
  }

  // setTensi(val: Tensi) {
  //   this.tensi = {
  //     sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
  //     diastole: !val.diastole && val.diastole != 0 ? null : Number(val.diastole)
  //   };
  // }

  // setTd(val) {
  //   this.sistole = val[0];
  //   this.diastole = val[1];
  // }
  setFrekNadi(val) {
    this.nadi = val;
  }

  checkAlerts() {
    const alerts = [];
    if (this.djj != null && this.djj !== "") {
      const djjN = Number(this.djj);
      if (!isNaN(djjN) && (djjN < 110 || djjN > 160)) {
        alerts.push(`DJJ ${djjN} di luar zona normal (110-160 bpm) — Waspada Fetal Distress`);
      }
    }
    const sis = Number(this.sistole);
    const dia = Number(this.diastole);
    if ((this.sistole != null && sis >= 160) || (this.diastole != null && dia >= 110)) {
      alerts.push(`Hipertensi Berat (${this.sistole}/${this.diastole}) — Curiga Preeklampsia/Eklampsia`);
    }
    if (this.suhu != null && this.suhu !== "") {
      const suhuN = Number(this.suhu);
      if (!isNaN(suhuN) && suhuN >= 38) {
        alerts.push(`Suhu ${this.suhu}°C — Curiga Korioamnionitis / Sepsis`);
      }
    }
    alerts.forEach((msg) => appModule.sendErrorAlert(msg));
  }

  optionServiks = [4, 5, 6, 7, 8, 9, 10];

  // djjData = [null, null, 120, null, 130, null, 130];
  // djjData =
  // djjData = [];
  // serviksData = {
  //   serviks: [null, null, 5, null, 6, null, 10],
  //   kepala: [null, null, 4, null, 3, null, 0],
  // };
  hisData = [1, 3, 3, 4, 4, 5];
  // hisData = {
  // durasi: [10, 39, 36, 45, 45, 15],
  // durasiData = ["red", "red", "red", "red", "red"];
  // kontraksiData = [1, 2, 3, 4, 5];
  // };

  get partograf() {
    return storePartograf.partograf;
  }

  get pembuatPartograf(): string {
    return pembuatLabel(this.partograf);
  }

  get djjData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      x = this.partograf.partograf.map((item) => item.djj);
    }
    return x;
  }

  get nadiData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      // const td = this.partograf.partograf.map((item) => [
      //   item.tv.sistole,
      //   item.tv.diastole,
      // ]);
      // const n = this.partograf.partograf.map((item) => item.tv.nadi);
      // x = {
      //   tekananDarah: td,
      //   nadi: n,
      // };
      x = this.partograf.partograf.map((item) => item.tv.nadi);
    }
    return x;
  }

  get tdData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      x = this.partograf.partograf.map((item) => [
        item.tv.sistole,
        item.tv.diastole,
      ]);
      // const n = this.partograf.partograf.map((item) => item.tv.nadi);
      // x = {
      //   tekananDarah: td,
      //   nadi: n,
      // };
      // x = this.partograf.partograf.map((item) => item.tv.nadi);
    }
    return x;
  }

  get durasiData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      x = this.partograf.partograf.map((item) => this.color(item.his.durasi));
    }
    return x;
  }
  color(val) {
    if (val > 40) {
      return "black";
    } else if (val >= 20) {
      return "rgb(90, 90, 90)";
    } else if (val > 0) {
      return "rgb(180, 180, 180)";
    } else {
      return null;
    }
  }

  get kontraksiData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      x = this.partograf.partograf.map((item) => item.his.kontraksi);
    }
    return x;
  }

  get hisDataa() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      const d = this.partograf.partograf.map((item) => item.his.durasi);
      const k = this.partograf.partograf.map((item) => item.his.kontraksi);
      x = {
        durasi: d,
        kontraksi: k,
      };
    } else {
      x = {
        durasi: [],
        kontraksi: [],
      };
    }
    return x;
  }

  get serviksData() {
    let x: any;
    if (this.partograf && this.partograf.partograf.length > 0) {
      const s = this.partograf.partograf.map((item) => item.serviks);
      const k = this.partograf.partograf.map((item) => item.kepala);
      const j = this.partograf.partograf.map((item) =>
        item.jam.substring(0, 5)
      );
      x = {
        serviks: s,
        kepala: k,
        jam: j,
      };
    } else {
      x = {
        serviks: [],
        kepala: [],
        jam: [],
      };
    }
    return x;
  }

  mounted() {
    storePartograf.getPartografByReg(this.register);
    this.jamAktual = new Date();
  }

  submit() {
    // this.djjData = [null, null, 120, null, 130, null, 130];
    // this.$root.$refs.A.hallo();
    //   console.log(this.djjData);
    //   this.djjData.push(parseInt(this.djj));
    //   console.log(this.djjData);
    //   // this.serviksData.serviks.push(parseInt(this.serviks));
    //   // this.serviksData.kepala.push(parseInt(this.kepala));
    //   this.djj = null;
    //   // this.serviks = null;
    //   // this.kepala = null;
    // this.durasiData = ["green", "green"];
    // this.kontraksiData = [1, 2];
  }

  get stateuser() {
    return userModule.user;
  }
  get pasien(): any {
    return storePasien.identitasPasien;
  }

  get input(): any {
    const inp: any = {
      tanggal: moment().format("YYYY-MM-DD"),
      register_id: this.register,
      pasien_rm: this.rm,
      pasien_umur: this.pasien ? this.pasien.umur : null,
      unit_id: this.stateuser.unit_id,
      ketuban_status: this.ketubanStatus,
      ketuban_pecah: this.ketubanStatus === "sudah" ? toSqlDateTime(this.ketubanPecah) : null,
      mules_sejak: toSqlDateTime(this.mulesSejak),
      g: this.g,
      p: this.p,
      a: this.a,
      nama_bapak: this.nama_bapak,
      tempat_asal: this.tempat_asal,
      masuk_tanggal_pukul: toSqlDateTime(this.masuk_tanggal_pukul),
      partograf: [],
    };
    return inp;
  }

  get catatanPersalinan(): CatatanPersalinan | null {
    return this.partograf ? (this.partograf as any).catatan_persalinan || null : null;
  }

  get jamKolom(): string[] {
    return this.partograf ? this.partograf.partograf.map((item: any) => item.jam) : [];
  }

  get anchor(): any {
    return anchorOf(this.partograf as any);
  }

  get anchorTersimpan(): boolean {
    return hasStoredAnchor(this.partograf as any);
  }

  get loadingPartograf(): boolean {
    return storePartograf.loading;
  }

  get headerInput(): any {
    const { partograf, ...header } = this.input;
    return header;
  }

  get perluAnchorBaru(): boolean {
    return !this.anchor || this.dtPartograf.length === 0;
  }

  get target(): any {
    if (this.perluAnchorBaru) return null;
    return resolveIndex(this.anchor, this.jamAktual);
  }

  get kolomHint(): { text: string; color: string } | null {
    if (!this.jamAktual) return null;

    if (this.perluAnchorBaru) {
      const mulai = floorToHalfHour(toMoment(this.jamAktual) || moment());
      return {
        text: "Observasi pertama — kolom grid dimulai pukul " + mulai.format("HH:mm"),
        color: "grey--text",
      };
    }

    const t = this.target;
    if (!t) return null;
    if (t.error) return { text: t.error, color: "red--text" };

    if (this.editingIndex === t.index) {
      return {
        text: "Sedang mengedit observasi pada kolom " + kolomLabel(this.anchor, t.index),
        color: "blue--text",
      };
    }

    const slot = this.dtPartograf[t.index];
    if (slot && !isSlotEmpty(slot)) {
      return {
        text:
          "Kolom " +
          kolomLabel(this.anchor, t.index) +
          " sudah terisi (" +
          jamTampil(slot) +
          ") — akan ditimpa",
        color: "orange--text text--darken-3",
      };
    }

    return {
      text: "Masuk kolom " + kolomLabel(this.anchor, t.index),
      color: "grey--text",
    };
  }

  get gridRange(): string {
    return this.anchor ? gridRangeLabel(this.anchor) : "-";
  }

  applySlot(slot: any, aktual: any) {
    slot.jam_aktual = aktual.format(SQL_FORMAT);
    slot.djj = this.djj;
    slot.serviks = this.serviks;
    slot.kepala = this.kepala;
    slot.tv.sistole = this.sistole;
    slot.tv.diastole = this.diastole;
    slot.tv.nadi = this.nadi;
    slot.his.durasi = this.durasi;
    slot.his.kontraksi = this.kontraksi;
    slot.air_ketuban = this.air_ketuban;
    slot.moulase = this.moulase;
    slot.oksitosin_iu = this.oksitosin_iu;
    slot.oksitosin_tetes = this.oksitosin_tetes;
    slot.obat_cairan_iv = this.obat_cairan_iv;
    slot.suhu = this.suhu;
    slot.protein_urin = this.protein_urin;
    slot.aseton_urin = this.aseton_urin;
    slot.volume_urin = this.volume_urin;
  }

  simpan() {
    if (this.readOnly || this.saving) return;

    const aktualAwal = toMoment(this.jamAktual);
    if (!aktualAwal) {
      appModule.sendErrorAlert("Jam observasi wajib diisi terlebih dahulu.");
      return;
    }
    if (this.ketubanStatus === "sudah" && !this.ketubanPecah) {
      appModule.sendErrorAlert("Isi waktu ketuban pecah.");
      return;
    }
    if (!this.pasien) {
      appModule.sendErrorAlert("Data pasien belum termuat. Muat ulang halaman lalu coba lagi.");
      return;
    }

    const perluBuatRecord = !(this.partograf && this.partograf.id);
    const perluAnchorBaru = this.perluAnchorBaru;
    let anchor: any;
    let index: number;
    let aktual: any;

    if (perluAnchorBaru) {
      anchor = floorToHalfHour(aktualAwal);
      index = 0;
      aktual = aktualAwal;
    } else {
      const t = resolveIndex(this.anchor, this.jamAktual);
      if (t.error) {
        appModule.sendErrorAlert(t.error);
        return;
      }
      anchor = this.anchor;
      index = t.index;
      aktual = t.aktual;

      const slotLama = this.dtPartograf[index];
      if (
        this.editingIndex !== index &&
        slotLama &&
        !isSlotEmpty(slotLama) &&
        !confirmRemove(
          null,
          "Kolom " +
            kolomLabel(anchor, index) +
            " sudah terisi observasi pukul " +
            jamTampil(slotLama) +
            ". Timpa data tersebut?"
        )
      ) {
        return;
      }
    }

    this.saving = true;
    this.checkAlerts();

    const inp = this.input;
    inp.partograf = perluAnchorBaru ? buildSlots(anchor) : JSON.parse(JSON.stringify(this.dtPartograf));
    inp.waktu_mulai_observasi = anchor.format(SQL_FORMAT);
    while (inp.partograf.length < SLOT_COUNT) {
      inp.partograf.push(blankSlot(slotLabel(anchor, inp.partograf.length)));
    }
    this.applySlot(inp.partograf[index], aktual);

    const dt = perluBuatRecord ? SvcPartograf.post(inp) : SvcPartograf.put(this.partograf.id, inp);
    dt.then((res) => {
      if (res.data.status != 1) {
        appModule.sendErrorAlert(res.data.message);
        return;
      }
      appModule.NoticeDelay("Berhasil Simpan Partograf");
      this.editingIndex = index;
      storePartograf.getPartografByReg({ reg: this.register, silent: true });
    })
      .catch(() => {
        // alert error sudah ditampilkan oleh interceptor axios
      })
      .finally(() => {
        this.saving = false;
      });
  }

  savingIdentitas = false;

  async simpanIdentitas() {
    if (this.readOnly || this.savingIdentitas) return;

    if (!this.pasien) {
      appModule.sendErrorAlert("Data pasien belum termuat. Muat ulang halaman lalu coba lagi.");
      return;
    }
    if (this.ketubanStatus === "sudah" && !this.ketubanPecah) {
      appModule.sendErrorAlert("Isi waktu ketuban pecah.");
      return;
    }

    this.savingIdentitas = true;
    try {
      if (this.partograf && this.partograf.id) {
        const res = await SvcPartograf.put(this.partograf.id, this.headerInput);
        if (res.data.status != 1) {
          appModule.sendErrorAlert(res.data.message);
          return;
        }
        await storePartograf.getPartografByReg({ reg: this.register, silent: true });
      } else if (!(await storePartograf.ensurePartograf(this.headerInput))) {
        return;
      }
      appModule.NoticeDelay("Identitas persalinan disimpan");
    } catch {
      // alert error sudah ditampilkan oleh service
    } finally {
      this.savingIdentitas = false;
    }
  }

  async hapusObservasi(index: number) {
    if (this.readOnly || this.deleting) return;
    if (!this.partograf || !this.partograf.id) return;

    const slot = this.dtPartograf[index];
    if (!confirmRemove("observasi pukul " + jamTampil(slot))) return;

    this.deleting = true;
    try {
      const res = await storePartograf.deleteObservasi({
        id: this.partograf.id,
        index,
        reg: this.register,
      });
      if (res && res.data && res.data.status != 1) {
        appModule.sendErrorAlert(res.data.message);
        return;
      }
      appModule.NoticeDelay("Observasi dihapus");
      if (this.editingIndex === index) this.batalEdit();
    } finally {
      this.deleting = false;
    }
  }

  batalEdit() {
    this.editingIndex = null;
    this.jamAktual = new Date();
    this.resetInputObservasi();
  }

  resetInputObservasi() {
    this.djj = null;
    this.serviks = null;
    this.kepala = null;
    this.sistole = null;
    this.diastole = null;
    this.nadi = null;
    this.durasi = null;
    this.kontraksi = null;
    this.air_ketuban = null;
    this.moulase = null;
    this.oksitosin_iu = null;
    this.oksitosin_tetes = null;
    this.obat_cairan_iv = "";
    this.suhu = null;
    this.protein_urin = null;
    this.aseton_urin = null;
    this.volume_urin = null;
  }


  cetakPdf() {
    // Buka halaman cetak webview (grafik = tampilan) di tab baru → user simpan sebagai PDF via print.
    if (this.register) {
      const route = this.$router.resolve({
        name: "PartografPrint",
        params: { register: String(this.register) },
      });
      window.open(route.href, "_blank");
    }
  }

  openSignDialog() {
    this.passwordSign = "";
    this.dialogSign = true;
  }

  async doSign() {
    if (!this.partograf || !this.partograf.id) return;
    this.signing = true;
    try {
      const res = await storePartograf.signPartograf({ id: this.partograf.id, password: this.passwordSign });
      if (res && res.data && res.data.status === 1) {
        appModule.NoticeDelay("Berhasil menandatangani Partograf");
        this.dialogSign = false;
      }
    } finally {
      this.signing = false;
    }
  }

  onPartusMacetAlert(payload) {
    appModule.sendErrorAlert(`PARTUS MACET — Pembukaan serviks ${payload.serviks}cm melewati garis bertindak. Pertimbangkan SC / Vakum / Rujuk SpOG.`);
  }

  onCatatanSaved() {
    // refresh partograf state sudah dilakukan oleh store action saveCatatanPersalinan
  }

  dtPartograf = [];

  @Watch("partograf")
  changeDataSuket(val) {
    if (!val) return;

    this.dtPartograf = val.partograf || [];
    this.ketubanStatus = val.ketuban_status || (val.ketuban_pecah ? "sudah" : "belum");
    this.ketubanPecah = val.ketuban_pecah ? moment(val.ketuban_pecah).toDate() : null;
    this.mulesSejak = val.mules_sejak ? moment(val.mules_sejak).toDate() : null;
    this.masuk_tanggal_pukul = val.masuk_tanggal_pukul ? moment(val.masuk_tanggal_pukul).toDate() : null;
    this.g = val.g;
    this.p = val.p;
    this.a = val.a;
    this.nama_bapak = val.nama_bapak || "";
    this.tempat_asal = val.tempat_asal || "";

    if (this.editingIndex !== null && this.dtPartograf[this.editingIndex]) {
      this.loadSlot(this.editingIndex);
    }
  }

  loadSlot(index: number) {
    const row: any = this.dtPartograf[index];
    if (!row) return;

    this.editingIndex = index;
    this.jamAktual = row.jam_aktual
      ? moment(row.jam_aktual).toDate()
      : this.anchor
      ? this.anchor.clone().add(index * 30, "minutes").toDate()
      : new Date();

    this.djj = row.djj;
    this.serviks = row.serviks;
    this.kepala = row.kepala;
    this.sistole = row.tv ? row.tv.sistole : null;
    this.diastole = row.tv ? row.tv.diastole : null;
    this.nadi = row.tv ? row.tv.nadi : null;
    this.durasi = row.his ? row.his.durasi : null;
    this.kontraksi = row.his ? row.his.kontraksi : null;
    this.air_ketuban = row.air_ketuban || null;
    this.moulase = row.moulase || null;
    this.oksitosin_iu = row.oksitosin_iu || null;
    this.oksitosin_tetes = row.oksitosin_tetes || null;
    this.obat_cairan_iv = row.obat_cairan_iv || "";
    this.suhu = row.suhu || null;
    this.protein_urin = row.protein_urin || null;
    this.aseton_urin = row.aseton_urin || null;
    this.volume_urin = row.volume_urin || null;
  }

}
